const getters = {
  authKey: state => state.user.authKey,
  sessionId: state => state.user.sessionId,
  userInfo: state => state.user.userInfo,
  menus: state => state.user.menus
}

export default getters
